export const getFormattedDate = (date: string) => {
  if (!date || !date.trim()) return "";
  const d = new Date(date);
  return (
    d.toLocaleDateString("en-US", { timeZone: "UTC", month: "short" }) +
    " " +
    d.toLocaleDateString("en-US", { timeZone: "UTC", day: "2-digit" }) +
    ", " +
    d.toLocaleDateString("en-US", { timeZone: "UTC", year: "numeric" })
  );
};

export const getFormattedDateByString = (date: string) => {
  if (!date || !date.trim()) return "";
  const parts = date.split("/");
  if (parts.length !== 3) return "";
  const [day, month, year] = parts.map(Number);
  const d = new Date(Date.UTC(year, month - 1, day));
  if (isNaN(d.getTime())) return "";
  return (
    d.toLocaleDateString("en-US", { timeZone: "UTC", month: "short" }) +
    " " +
    d.toLocaleDateString("en-US", { timeZone: "UTC", day: "2-digit" }) +
    ", " +
    d.toLocaleDateString("en-US", { timeZone: "UTC", year: "numeric" })
  );
};

export const formatDate = (date: string) => {
  const d = new Date(date);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  });
};

export const getFormattedTime = (date: string) => {
  const d = new Date(date);
  return d.toLocaleTimeString("en-US", {
    timeZone: "UTC",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const getTotalOrderAmountRow = (sku: any) => {
  if (!sku || sku === null) {
    return 0;
  }
  let totalAmount = 0;
  const quantity = sku.OrderQuantity || 0;
  const cost = sku.CostMetricCost || 0;
  const duration = sku.OrderInterval || 0;
  totalAmount += cost * quantity * duration;
  if (sku.SkuRelation && sku.SkuRelation.length > 0) {
    sku.SkuRelation.forEach((relation: any) => {
      const quantity = relation.OrderQuantity || 0;
      const cost = relation.CostMetricCost || 0;
      const duration = relation.OrderInterval || 0;
      totalAmount += cost * quantity * duration;
    });
  }
  return totalAmount;
};

export const onViewOrderItems = (orderId: number, orderDetails: any[]) => {
  const updatedOrderDetails = orderDetails.map((order: any) => {
    if (order.orderParentId === orderId) {
      return {
        ...order,
        isExpanded: !order.isExpanded,
      };
    }
    return order;
  });
  return updatedOrderDetails;
};

export const onViewSkuItems = (skuID: number, skuDetails: any[]) => {
  const updatedSkuDetails = skuDetails.map((skus: any) => {
    if (skus.SkuId === skuID) {
      return {
        ...skus,
        isExpanded: !skus.isExpanded,
      };
    }
    return skus;
  });
  return updatedSkuDetails;
};

export const handleCloseDetails = (orderId: number, orderDetails: any[]) => {
  const updatedOrderDetails = orderDetails.map((order: any) => {
    if (order.orderParentId === orderId) {
      return {
        ...order,
        isExpanded: !order.isExpanded,
      };
    }
    return order;
  });
  return updatedOrderDetails;
};

export const handleCloseSkuDetails = (skuId: number, skuDetails: any[]) => {
  const updatedOrderDetails = skuDetails.map((skus: any) => {
    if (skus.SkuId === skuId) {
      return {
        ...skuDetails,
        isExpanded: !skus.isExpanded,
      };
    }
    return skus;
  });
  return updatedOrderDetails;
};

export type ArrowDirection = "up" | "down";

export const getArrowDirection = (
  orderId: number,
  orderDetails: any[],
): ArrowDirection => {
  const order = orderDetails.find(
    (order: any) => order.orderParentId === orderId,
  );
  return order && order.isExpanded ? "up" : "down";
};

export const getArrowDirectionSku = (
  skuId: number,
  orderDetails: any[],
): ArrowDirection => {
  const order = orderDetails.find((order: any) => order.SkuId === skuId);
  return order && order.isExpanded ? "up" : "down";
};

export const getTotalOrderAmount = (order: any) => {
  let totalAmount = 0;
  const quantity = order.Quantity || 0;
  const cost = order.CostMetricCost || 0;
  const duration = order.Intervals || 0;
  totalAmount += cost * quantity * duration;
  return totalAmount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const getTotalRecoveriesAmount = (orderAmount: any) => {
  const totalAmount = Number(orderAmount) || 0;
  return totalAmount.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const formatCurrency = (amount: number) => {
  const truncated = Number(amount.toFixed(2));
  return truncated.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
};

export const hasMoreThanTwoDecimals = (num: string) => {
  const decimalPart = num.toString().split(".")[1];
  return decimalPart && decimalPart.length > 2;
};

export const truncateToTwoDecimals = (num: number) => {
  return Math.floor(num * 100) / 100;
};

const metricUnitMapping: Record<string, string> = {
  gb: "GB",
  hrs: "Hour",
  cost: "Instance",
  token: "Token",
  license: "License",
  unit: "Unit",
};
export const getUnitsUsed = (
  costMetric: string,
  quantity: number | undefined | null | "",
) => {
  if (quantity === null || quantity === undefined || quantity === "") {
    return "";
  }
  const metricUnit = costMetric?.split("_")?.[1]?.trim();
  return metricUnit && Object.keys(metricUnitMapping).includes(metricUnit)
    ? metricUnitMapping[metricUnit] + (quantity && quantity > 1 ? "s" : "")
    : metricUnit;
};
